import React from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../../services/auth';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [tip, setTip] = React.useState('');

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const normalizedEmail = String(email || '').trim().toLowerCase();
    if (!normalizedEmail) {
      setTip('请输入邮箱');
      return;
    }
    setLoading(true);
    setTip('');
    try {
      const resp = await forgotPassword(normalizedEmail);
      setTip(resp?.detail || '若该邮箱对应已验证的客户主账号，重置链接已发送');
    } catch (err: any) {
      setTip(err?.response?.data?.detail || '提交失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md w-[520px]">
        <h1 className="text-2xl font-bold mb-6 text-center">忘记密码</h1>
        <p className="mb-4 text-sm text-gray-600">仅支持客户主账号通过已验证邮箱找回密码</p>
        {tip ? <div className="mb-4 rounded border border-blue-200 bg-blue-50 px-3 py-2 text-sm text-blue-700">{tip}</div> : null}
        <form onSubmit={submit}>
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">邮箱</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="请输入已验证邮箱"
            disabled={loading}
            required
          />
          <button
            type="submit"
            className="mt-6 w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 disabled:opacity-60"
            disabled={loading}
          >
            {loading ? '提交中...' : '发送重置链接'}
          </button>
        </form>
        <div className="mt-4 text-center text-sm">
          <Link to="/login" className="text-blue-600 hover:text-blue-700">返回登录</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
